import React from "react";
import { Frame, SubTitle, Title } from "./styles";
import styled from "styled-components";

export interface Props {
	title: string;
	subtitle: string;
	align?: "left" | "center";
	color?: string;
	className?: string;
}
const SectionTitle: React.FC<Props> = (props) => {
	const { title, subtitle, align, color, className } = props;
	return (
		<Frame align={align} color={color} className={className}>
			<Title align={align}>{title}</Title>
			<SubTitle align={align}>{subtitle}</SubTitle>
		</Frame>
	);
};

export default styled(SectionTitle)``;
